module.exports = __webpack_public_path__ + "img/template-role.67840cb0.svg";